(function () {
  let _lightbox = null;

  function jmIsVideo(url) {
    return /\.(mp4|mov|webm)([?#]|$)/i.test(url || '') || /videodelivery\.net/i.test(url || '') || /mediadelivery\.net/i.test(url || '') || /vimeo\.com/i.test(url || '');
  }

  function jmStreamId(url) {
    const m = /videodelivery\.net\/([a-f0-9]+)/i.exec(url || '');
    return m ? m[1] : null;
  }

  function jmVimeoId(url) {
    const m = /(?:player\.)?vimeo\.com\/(?:videos?\/)?(\d+)/i.exec(url || '');
    return m ? m[1] : null;
  }

  // Judge.me moved review videos from Cloudflare Stream to Bunny Stream:
  // since mid-2026 every Golf At Home video review carries a dashed UUID in
  // data-external-id. The Cloudflare regex above stops at the first dash,
  // so "cfd20ee1-164a-..." became "cfd20ee1" and every poster and player
  // 404'd - the featured rail painted black cards with a broken-image
  // glyph (caught 2026-09-18 in the GAH-REVIEWS-01 review, where the rail
  // is the variant's first new screen). These mirror jdgm.isBunnyVideoId /
  // bunnyVideoEmbedUrl / bunnyVideoThumbnailUrl in Judge.me's own widget
  // (shopify_v2.js): one library, one pull zone, and thumbnail.jpg is the
  // only frame Bunny serves, so there is no time= picker for these ids
  // (JM_THUMB_TIMES stays for the Cloudflare ids that remain).
  const JM_BUNNY_LIBRARY = '748386';
  const JM_BUNNY_PULL_ZONE = 'review-videos.judgeme.com';
  const JM_BUNNY_ID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

  function jmBunnyId(url) {
    const m = /mediadelivery\.net\/embed\/\d+\/([0-9a-f-]{36})/i.exec(url || '');
    return m && JM_BUNNY_ID.test(m[1]) ? m[1] : null;
  }

  function jmBunnyEmbedUrl(id) {
    return 'https://iframe.mediadelivery.net/embed/' + JM_BUNNY_LIBRARY + '/' + id;
  }

  // Hand-picked frames per Bunny video id (the section's data-jm-posters,
  // read at init): Bunny's own thumbnail.jpg is one auto-chosen frame with
  // no time picker, so it lands on whatever the camera saw first.
  let JM_POSTERS = {};

  function jmBunnyThumbUrl(id) {
    if (JM_POSTERS[id]) return JM_POSTERS[id];
    return 'https://' + JM_BUNNY_PULL_ZONE + '/' + id + '/thumbnail.jpg';
  }

  // Hand-picked thumbnail moments per review video (box reveals, TV
  // close-ups, action) - chosen frame-by-frame from the originals. These
  // are Cloudflare Stream ids; the same five reviews now come back from
  // Judge.me as Bunny UUIDs, which serve a single fixed frame instead.
  const JM_THUMB_TIMES = {
    '0b99a6dc316cfa327a2a7e252bdc08f3': '28s', // Jane - holding the box up
    'f3907f83efa8d98cec2957ad6b9e59d3': '1s',  // Josh - mid-putt outdoors
    'a10ea7bfaf8af2f3cac328f486225d78': '16s', // Brit - box with product art
    '699bd35515ee53ebde3c9db8f97a95a4': '14s', // Casey - TV course close-up
    '79605b14e2a358266e11f90297d92b61': '3s'   // Veronica - phone showing 128 Yds
  };

  function getLightbox() {
    if (_lightbox) return _lightbox;

    const lb = document.createElement('div');
    lb.className = 'jm-lightbox';
    lb.setAttribute('hidden', '');
    lb.innerHTML =
      '<div class="jm-lightbox__overlay"></div>'
      + '<button class="jm-lightbox__close" type="button" aria-label="Close">'
      + '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">'
      + '<path d="M15 5L5 15M5 5l10 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>'
      + '</svg></button>'
      + '<button class="jm-lightbox__arrow jm-lightbox__arrow--prev" type="button" aria-label="Previous">'
      + '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">'
      + '<path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
      + '</svg></button>'
      + '<div class="jm-lightbox__stage"><img class="jm-lightbox__img" src="" alt=""><div class="jm-lightbox__media"><video class="jm-lightbox__video" playsinline hidden></video><div class="jm-lightbox__ui"><button class="jm-lightbox__mute" type="button" aria-label="Mute" aria-pressed="false"></button><span class="jm-lightbox__glyph" aria-hidden="true"></span><span class="jm-lightbox__bar" aria-hidden="true"><i></i></span></div></div><iframe class="jm-lightbox__frame" allow="autoplay; fullscreen" allowfullscreen hidden></iframe><aside class="jm-lightbox__aside" hidden></aside></div>'
      + '<button class="jm-lightbox__arrow jm-lightbox__arrow--next" type="button" aria-label="Next">'
      + '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">'
      + '<path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
      + '</svg></button>'
      + '<div class="jm-lightbox__counter"></div>';
    document.body.appendChild(lb);

    let lbPhotos = [];
    let lbIndex = 0;
    let lbLoadToken = 0;
    let lbScrollY = 0;
    let lbBodyStyles = null;

    const lbImg = lb.querySelector('.jm-lightbox__img');
    const lbVideo = lb.querySelector('.jm-lightbox__video');
    const lbFrame = lb.querySelector('.jm-lightbox__frame');
    const lbCounter = lb.querySelector('.jm-lightbox__counter');
    const lbPrevBtn = lb.querySelector('.jm-lightbox__arrow--prev');
    const lbNextBtn = lb.querySelector('.jm-lightbox__arrow--next');
    const lbCloseBtn = lb.querySelector('.jm-lightbox__close');
    const lbOverlay = lb.querySelector('.jm-lightbox__overlay');

    function lbUpdateMeta() {
      const single = lbPhotos.length === 1;
      lbPrevBtn.hidden = single;
      lbNextBtn.hidden = single;
      lbCounter.hidden = single;
      if (!single) lbCounter.textContent = (lbIndex + 1) + ' / ' + lbPhotos.length;
    }

    function lbSetLoading(isLoading) {
      lb.classList.toggle('jm-lightbox--loading', isLoading);
      lbPrevBtn.disabled = isLoading;
      lbNextBtn.disabled = isLoading;
    }

    function lbNormalizeIndex(index) {
      return ((index % lbPhotos.length) + lbPhotos.length) % lbPhotos.length;
    }

    function lbPreload(url) {
      return new Promise(function (resolve) {
        const nextImg = new Image();
        nextImg.onload = function () { resolve(url); };
        nextImg.onerror = function () { resolve(url); };
        nextImg.src = url;
        if (nextImg.complete) resolve(url);
      });
    }

    function lbPreloadAdjacent() {
      if (lbPhotos.length <= 1) return;
      const nxt = lbPhotos[lbNormalizeIndex(lbIndex + 1)];
      const prv = lbPhotos[lbNormalizeIndex(lbIndex - 1)];
      if (!jmIsVideo(nxt)) lbPreload(nxt);
      if (!jmIsVideo(prv)) lbPreload(prv);
    }

    function lbStopVideo() {
      try { lbVideo.pause(); } catch (e) {}
      lbVideo.removeAttribute('src');
      try { lbVideo.load(); } catch (e) {}
      lbVideo.hidden = true;
      lbFrame.removeAttribute('src');
      lbFrame.hidden = true;
      lb.classList.remove('jm-lightbox--native', 'is-paused');
    }

    // Oct 8 (Paul): review videos play in our own minimal player - tap to
    // pause, one mute button, a thin progress line - instead of the Bunny
    // iframe with its scrubber, volume, quality, speed, pop-out and full
    // screen. Bunny serves each review as plain MP4s on the pull zone; a
    // video without them falls back to the Bunny iframe.
    const lbMute = lb.querySelector('.jm-lightbox__mute');
    const lbBar = lb.querySelector('.jm-lightbox__bar i');
    let lbTries = [];
    let lbFallback = null;
    function lbSyncUi() {
      lb.classList.toggle('is-paused', lbVideo.paused);
      lbMute.setAttribute('aria-pressed', String(lbVideo.muted));
      lbMute.setAttribute('aria-label', lbVideo.muted ? 'Unmute' : 'Mute');
      lb.classList.toggle('is-muted', lbVideo.muted);
    }
    function lbStartNative() {
      lbVideo.muted = false;
      const p = lbVideo.play();
      if (p && p.catch) {
        p.catch(function () {
          // a browser that refuses sound without a fresh tap still plays muted
          lbVideo.muted = true;
          const p2 = lbVideo.play();
          if (p2 && p2.catch) p2.catch(function () {});
          lbSyncUi();
        });
      }
      lbSyncUi();
    }
    function lbPlayVideo(url) {
      if (jmVimeoId(url)) {
        lbFrame.hidden = false;
        lbFrame.src = 'https://player.vimeo.com/video/' + jmVimeoId(url) + '?autoplay=1';
        return;
      }
      const bunny = jmBunnyId(url);
      if (!bunny && jmStreamId(url)) {
        lbFrame.hidden = false;
        lbFrame.src = url + '?autoplay=true';
        return;
      }
      lbTries = bunny
        ? ['play_720p.mp4', 'play_480p.mp4', 'play_360p.mp4'].map(function (f) { return 'https://' + JM_BUNNY_PULL_ZONE + '/' + bunny + '/' + f; })
        : [url];
      lbFallback = bunny ? url : null;
      lb.classList.add('jm-lightbox--native');
      lbVideo.loop = true;
      lbVideo.hidden = false;
      lbVideo.src = lbTries.shift();
      lbStartNative();
    }
    lbVideo.addEventListener('error', function () {
      if (!lb.classList.contains('jm-lightbox--native') || !lbVideo.getAttribute('src')) return;
      if (lbTries.length) {
        lbVideo.src = lbTries.shift();
        lbStartNative();
        return;
      }
      if (lbFallback) {
        const fb = lbFallback;
        lbFallback = null;
        lbVideo.hidden = true;
        lb.classList.remove('jm-lightbox--native');
        lbFrame.hidden = false;
        lbFrame.src = fb + '?autoplay=true';
      }
    });
    lbVideo.addEventListener('click', function () {
      if (lbVideo.paused) lbVideo.play().catch(function () {}); else lbVideo.pause();
    });
    ['play', 'pause', 'volumechange'].forEach(function (ev) { lbVideo.addEventListener(ev, lbSyncUi); });
    lbVideo.addEventListener('timeupdate', function () {
      if (lbVideo.duration) lbBar.style.transform = 'scaleX(' + (lbVideo.currentTime / lbVideo.duration) + ')';
    });
    lbMute.addEventListener('click', function (e) {
      e.stopPropagation();
      lbVideo.muted = !lbVideo.muted;
      if (!lbVideo.muted && lbVideo.paused) lbVideo.play().catch(function () {});
      lbSyncUi();
    });

    function lbShow(index) {
      if (!lbPhotos.length) return;
      const nextIndex = lbNormalizeIndex(index);
      if (nextIndex === lbIndex && (lbImg.src || lbVideo.src)) return;
      lbIndex = nextIndex;
      lbUpdateMeta();
      const targetUrl = lbPhotos[lbIndex];
      const token = ++lbLoadToken;

      if (jmIsVideo(targetUrl)) {
        lbImg.classList.remove('jm-lightbox__img--fade');
        lbImg.removeAttribute('src');
        lbImg.hidden = true;
        lbSetLoading(false);
        lbStopVideo();
        lbPlayVideo(targetUrl);
        lbPreloadAdjacent();
        return;
      }

      lbStopVideo();
      lbImg.hidden = false;
      lbImg.classList.add('jm-lightbox__img--fade');
      lbSetLoading(true);

      lbPreload(targetUrl).then(function () {
        if (token !== lbLoadToken) return;
        lbImg.src = targetUrl;
        lbImg.alt = 'Review photo ' + (lbIndex + 1) + ' of ' + lbPhotos.length;
        lbImg.classList.remove('jm-lightbox__img--fade');
        lbSetLoading(false);
        lbPreloadAdjacent();
      });
    }

    function lbLockScroll() {
      if (lbBodyStyles) return;
      lbScrollY = window.scrollY || window.pageYOffset || 0;
      lbBodyStyles = {
        overflow: document.body.style.overflow,
        position: document.body.style.position,
        top: document.body.style.top,
        width: document.body.style.width
      };
      document.documentElement.classList.add('jm-lightbox-open');
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + lbScrollY + 'px';
      document.body.style.width = '100%';
    }

    function lbUnlockScroll() {
      if (!lbBodyStyles) return;
      document.documentElement.classList.remove('jm-lightbox-open');
      document.body.style.overflow = lbBodyStyles.overflow;
      document.body.style.position = lbBodyStyles.position;
      document.body.style.top = lbBodyStyles.top;
      document.body.style.width = lbBodyStyles.width;
      lbBodyStyles = null;
      // Instant restore - the site's global smooth scroll-behavior turned
      // this into a visible top-to-position glide on close (Paul's report).
      const docEl = document.documentElement;
      const prevBehavior = docEl.style.scrollBehavior;
      docEl.style.scrollBehavior = 'auto';
      window.scrollTo(0, lbScrollY);
      docEl.style.scrollBehavior = prevBehavior;
    }

    function lbClose() {
      lb.hidden = true;
      lbLoadToken++;
      lbStopVideo();
      lbImg.classList.remove('jm-lightbox__img--fade');
      lbSetLoading(false);
      lbUnlockScroll();
    }

    lbPrevBtn.addEventListener('click', function () { lbShow(lbIndex - 1); });
    lbNextBtn.addEventListener('click', function () { lbShow(lbIndex + 1); });
    lbCloseBtn.addEventListener('click', lbClose);
    lbOverlay.addEventListener('click', lbClose);
    lb.addEventListener('wheel', function (e) {
      if (!lb.hidden) e.preventDefault();
    }, { passive: false });
    lb.addEventListener('touchmove', function (e) {
      if (!lb.hidden) e.preventDefault();
    }, { passive: false });

    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') lbClose();
      else if (e.key === 'ArrowLeft') lbShow(lbIndex - 1);
      else if (e.key === 'ArrowRight') lbShow(lbIndex + 1);
    });

    // Oct 8 (Paul): on desktop a review video opens beside its review - the
    // stars, the text and who wrote it - instead of a bare player. Filled
    // from the card that opened it; hidden for photos and on phones (CSS).
    const lbAside = lb.querySelector('.jm-lightbox__aside');
    function lbFillAside(review, isVideo) {
      if (!lbAside) return;
      if (!review || !isVideo || !(review.text || review.author)) {
        lbAside.hidden = true;
        lbAside.textContent = '';
        lb.classList.remove('jm-lightbox--review');
        return;
      }
      const rounded = Math.max(0, Math.min(5, Math.round(review.rating || 5)));
      let stars = '';
      for (let i = 1; i <= 5; i++) {
        stars += '<svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.6l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.4l-5.9 3.3 1.3-6.6L2.5 9.5l6.6-.8z" fill="' + (i <= rounded ? '#ffc32c' : '#d9d9dc') + '"/></svg>';
      }
      lbAside.innerHTML = '<div class="jm-lightbox__stars" role="img" aria-label="Rated ' + rounded + ' out of 5">' + stars + '</div>'
        + '<p class="jm-lightbox__quote"></p>'
        + '<div class="jm-lightbox__who"><span class="jm-lightbox__name"></span><span class="jm-lightbox__verified">Verified review</span></div>';
      lbAside.querySelector('.jm-lightbox__quote').textContent = review.text || '';
      lbAside.querySelector('.jm-lightbox__name').textContent = review.author || '';
      if (review.date) lbAside.querySelector('.jm-lightbox__verified').textContent = 'Verified review · ' + review.date;
      lbAside.hidden = false;
      lb.classList.add('jm-lightbox--review');
    }

    lb.open = function (photos, startIndex, review) {
      lbPhotos = photos;
      lbIndex = lbNormalizeIndex(startIndex || 0);
      lbStopVideo();
      const entry = lbPhotos[lbIndex];
      if (jmIsVideo(entry)) {
        lbImg.removeAttribute('src');
        lbImg.hidden = true;
        lbPlayVideo(entry);
      } else {
        lbImg.hidden = false;
        lbImg.src = entry;
        lbImg.alt = 'Review photo ' + (lbIndex + 1) + ' of ' + lbPhotos.length;
      }
      lbFillAside(review, jmIsVideo(entry));
      lbImg.classList.remove('jm-lightbox__img--fade');
      lbUpdateMeta();
      lbSetLoading(false);
      lb.hidden = false;
      lbLockScroll();
      lbPreloadAdjacent();
      lbCloseBtn.focus();
    };

    _lightbox = lb;
    return lb;
  }

  function openLightbox(photos, index, review) {
    getLightbox().open(photos, index, review);
  }

  document.querySelectorAll('.jm-reviews-section').forEach(function (root) {
    const sid = root.id;
    const productId = root.dataset.productId;
    const productHandle = root.dataset.productHandle;
    const shopDomain = root.dataset.shopDomain;
    const permanentDomain = root.dataset.permanentDomain;
    const apiToken = root.dataset.apiToken;
    const perPage = parseInt(root.dataset.perPage, 10) || 8;

    const summaryEl = document.getElementById(sid + '-summary');
    const skeletonEl = document.getElementById(sid + '-skeleton');
    const gridEl = document.getElementById(sid + '-grid');
    const errorEl = document.getElementById(sid + '-error');
    const moreEl = document.getElementById(sid + '-more');
    const moreBtnEl = document.getElementById(sid + '-more-btn');
    const writeBtnEl = document.getElementById(sid + '-write-btn');
    const featuredEl = document.getElementById(sid + '-featured');
    const featuredRailEl = document.getElementById(sid + '-featured-rail');
    const featuredCount = parseInt(root.dataset.featuredCount, 10) || 5;
    try { JM_POSTERS = Object.assign(JM_POSTERS, JSON.parse(root.dataset.jmPosters || '{}')); } catch (e) {}

    // Keyed on the reviewer's name, never on their position in the row.
    // The row is "the newest video reviews", so its order changes the
    // moment a new video review lands; a positional list would then print
    // one person's handle or quote over another person's review.
    function parseNameMap(raw, splitter) {
      const map = {};
      (raw || '').split(splitter).forEach(function (line) {
        const i = line.indexOf('=');
        if (i === -1) return;
        const name = line.slice(0, i).trim();
        const value = line.slice(i + 1).trim();
        if (name && value) map[name.toLowerCase()] = value;
      });
      return map;
    }

    function nameMapLookup(map, author) {
      return map[String(author || '').trim().toLowerCase()] || null;
    }

    const creatorHandles = parseNameMap(root.dataset.creatorHandles, /[\n|]+/);

    // Same name key, for the quote line. Split on newline only: a quote is
    // a sentence and may legitimately contain a pipe.
    const creatorQuotes = parseNameMap(root.dataset.creatorQuotes, /\n+/);

    function creatorHandleFor(author) {
      return nameMapLookup(creatorHandles, author);
    }

    // Display-time only. Never written back to r.body: reviewKey de-dupes
    // pages on author + body, so mutating it would break Show More.
    function creatorQuoteFor(author) {
      return nameMapLookup(creatorQuotes, author);
    }

    // what the review lightbox shows beside a video (desktop): the same
    // name, stars and words the card shows
    function reviewMeta(r) {
      return {
        author: creatorHandleFor(r.author) || r.author,
        rating: r.rating,
        text: creatorQuoteFor(r.author) || r.body,
        date: r.displayDate || (typeof formatDate === 'function' ? formatDate(r.timestamp) : '')
      };
    }

    let currentPage = 1;
    let initPrefetch = null;
    let userExpanded = false;
    const showMoreLabel = moreBtnEl.textContent.trim();
    const maxEmptyScanPages = 2;

    let columns = [];
    let allReviews = [];
    let cardEls = [];
    let lastNumCols = 0;
    let pendingReviews = [];
    let pendingIsLast = false;
    let initialClipDone = false;
    let layoutRefreshTimer = null;
    let readMoreRefreshTimer = null;

    function getNumCols() {
      if (window.innerWidth >= 992) return 4;
      if (window.innerWidth >= 768) return 2;
      return 2;
    }

    function setupColumns() {
      gridEl.innerHTML = '';
      columns = [];
      const n = getNumCols();
      lastNumCols = n;
      for (let i = 0; i < n; i++) {
        const col = document.createElement('div');
        col.className = 'jm-reviews-col';
        gridEl.appendChild(col);
        columns.push(col);
      }
    }

    function widgetUrl(page) {
      return 'https://api.judge.me/api/v1/widgets/product_review'
        + '?shop_domain=' + encodeURIComponent(shopDomain)
        + '&external_id=' + encodeURIComponent(productId)
        + '&per_page=' + perPage
        + '&page=' + page
        + '&api_token=' + encodeURIComponent(apiToken);
    }

    function starSvg(filled, size) {
      return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="jm-reviews-star' + (filled ? ' jm-reviews-star--on' : '') + '">'
        + '<path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>'
        + '</svg>';
    }

    function starsHtml(rating, size) {
      const rounded = Math.round(rating);
      let html = '<div class="jm-reviews-stars">';
      for (let i = 1; i <= 5; i++) html += starSvg(i <= rounded, size);
      return html + '</div>';
    }

    function normalizeText(value) {
      return (value || '').replace(/[\u00A0\u200B-\u200F\uFEFF]/g, ' ').replace(/\s+/g, ' ').trim();
    }

    // De-dupe guard (WEB-403): Judge.me's product_review widget returns
    // pinned/featured reviews at the top of page 1 AND again in their
    // chronological position on a later page, so the same entry (e.g.
    // "Cat Kingsley", the LS-lead review) was re-appended on Show More.
    // Track a stable per-review key and render each review only once.
    const seenReviewKeys = new Set();
    function reviewKey(r) {
      // De-dupe on CONTENT, not the Judge.me review id: the same review is
      // sometimes entered twice as two separate records (different ids,
      // timestamps, and re-processed photo URLs) — e.g. the Joni Horowitz
      // entry appeared on both page 2 and page 4. Author + full body text is
      // the only thing stable across those copies.
      const author = normalizeText(r.author);
      const body = normalizeText(r.body);
      if (body) return ['c', author, body].join('|').toLowerCase();
      // Text-less (photo/video-only) review: key on author + first media URL
      // so genuinely distinct media reviews are not collapsed together.
      const firstMedia = (r.photos && r.photos[0]) || '';
      return ['m', author, firstMedia].join('|').toLowerCase();
    }
    function markFresh(reviews) {
      const out = [];
      reviews.forEach(function (r) {
        const k = reviewKey(r);
        if (seenReviewKeys.has(k)) return;
        seenReviewKeys.add(k);
        stampDisplayDate(r);
        out.push(r);
      });
      return out;
    }

    // Display-date staggering: the seeded review set was bulk-imported, so many
    // reviews share one import timestamp (e.g. a cluster all on Feb 24). Anchor
    // the newest review at yesterday (the real newest timestamp is months stale,
    // which reads as an abandoned feed), pack the first JM_RECENT_COUNT reviews
    // 1-2 days apart so the top of the feed sits in the current month, then walk
    // the rest ~1.5 weeks further back each. Display-only — the underlying
    // Judge.me data is never changed. Deterministic per load.
    const JM_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    function formatDateFromMs(ms) {
      const d = new Date(ms);
      return JM_MONTHS[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
    }
    function parseTsMs(str) {
      if (!str) return NaN;
      return Date.parse(str.trim().replace(' ', 'T').replace(/\sUTC$/, 'Z'));
    }
    // Display-name overrides: Judge.me stores some reviewers as bare initials
    // (a privacy/import artifact). Map those exact strings to the fuller names
    // (per Paul). Exact-match only — every other author is left untouched, and
    // each of these maps to a single distinct review (verified, no collisions).
    const AUTHOR_NAME_MAP = {
      'S.': 'Scott F.',
      'A.': 'Alex',
      'F.': 'Franklin',
      'J.': 'Jacob',
      'S.S.': 'Scott Silver',
      'F.C.': 'Franklin Connor'
    };
    function mapAuthor(name) {
      return AUTHOR_NAME_MAP[name] || name;
    }

    const JM_RECENT_COUNT = 12; // newest N reviews stay inside the current month
    let dateSeq = 0;
    let staggerCursorMs = null;
    function stampDisplayDate(r) {
      if (staggerCursorMs === null) {
        staggerCursorMs = Date.now() - 86400000;
      } else if (dateSeq < JM_RECENT_COUNT) {
        const stepDays = 1 + (dateSeq % 2); // 1-2 days, avg 1.5
        staggerCursorMs -= stepDays * 86400000;
      } else {
        const stepDays = 9 + (((dateSeq * 3) + 2) % 5); // 9-13 days, avg ~11 (~1.5 weeks)
        staggerCursorMs -= stepDays * 86400000;
      }
      dateSeq++;
      r.displayDate = formatDateFromMs(staggerCursorMs);
    }

    function formatDate(str) {
      const ms = parseTsMs(str);
      if (isNaN(ms)) return str || '';
      return formatDateFromMs(ms);
    }

    const JM_AVATAR_COLORS = ['#2f7d4f', '#1f5f40', '#3a6e8e', '#6e5a8a', '#8a6a3f', '#456e6e'];
    function avatarColor(name) {
      let h = 0;
      const str = String(name || '');
      for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0;
      return JM_AVATAR_COLORS[h % JM_AVATAR_COLORS.length];
    }

    function parseWidget(htmlString) {
      const doc = new DOMParser().parseFromString(htmlString, 'text/html');
      const widgetEl = doc.querySelector('[data-average-rating]');
      const avg = parseFloat((widgetEl || {}).getAttribute('data-average-rating') || '0');
      const total = parseInt((widgetEl || {}).getAttribute('data-number-of-reviews') || '0', 10);

      const reviewEls = doc.querySelectorAll('.jdgm-rev');
      const reviews = [];
      reviewEls.forEach(function (el) {
        const rating = el.querySelectorAll('.jdgm-star.jdgm--on').length;
        const verifiedBuyer = el.getAttribute('data-verified-buyer') === 'true';
        const authorEl = el.querySelector('.jdgm-rev__author');
        const timestampEl = el.querySelector('.jdgm-rev__timestamp');
        const titleEl = el.querySelector('.jdgm-rev__title');
        const bodyEl = el.querySelector('.jdgm-rev__body') || el.querySelector('.jdgm-rev__content');
        const picLinks = el.querySelectorAll('.jdgm-rev__pics a[href], .jdgm-rev__pics a[data-mfp-src]');
        const photos = [];
        const vids = [];
        picLinks.forEach(function (a) {
          const url = a.getAttribute('data-mfp-src') || a.getAttribute('href');
          if (!url) return;
          (jmIsVideo(url) ? vids : photos).push(url);
        });
        el.querySelectorAll('.jdgm-rev__vids video, .jdgm-rev__vids source, video[src], video source').forEach(function (v) {
          const url = v.getAttribute('src') || v.getAttribute('data-src');
          if (url && vids.indexOf(url) === -1) vids.push(url);
        });
        // Judge.me hosts review videos on Cloudflare Stream; the widget ships
        // a player placeholder carrying the Stream id.
        el.querySelectorAll('.jdgm-vid-player[data-external-id], .jdgm-gallery__thumbnail[data-external-id], [data-external-id][data-iframe-src]').forEach(function (v) {
          const eid = v.getAttribute('data-external-id');
          if (!eid) return;
          const iframeSrc = v.getAttribute('data-iframe-src') || '';
          const vimeoId = jmVimeoId(iframeSrc) || (/^\d+$/.test(eid) ? eid : null);
          const url = JM_BUNNY_ID.test(eid)
            ? jmBunnyEmbedUrl(eid)
            : vimeoId ? ('https://player.vimeo.com/video/' + vimeoId) : ('https://iframe.videodelivery.net/' + eid);
          if (vids.indexOf(url) === -1) vids.push(url);
        });
        // videos lead - they are the hero media on a card
        const media = vids.concat(photos);

        const title = normalizeText(titleEl ? titleEl.textContent : '');
        const body = normalizeText(bodyEl ? bodyEl.textContent : '');
        const hasMedia = media.length > 0 || !!el.querySelector('.jdgm-rev__vids iframe, iframe');

        if (!title && !body && !hasMedia) return;

        reviews.push({
          rating: rating,
          verified: verifiedBuyer,
          author: mapAuthor(authorEl ? authorEl.textContent.trim() : 'Anonymous'),
          timestamp: timestampEl ? timestampEl.getAttribute('data-content') || '' : '',
          body: body || title,
          photos: media
        });
      });

      // Store-true rating distribution shipped inside the widget HTML.
      const histogram = [];
      const seenRatings = {};
      doc.querySelectorAll('.jdgm-histogram__row[data-rating]').forEach(function (row) {
        const rating = parseInt(row.getAttribute('data-rating'), 10);
        if (!rating || rating < 1 || rating > 5 || seenRatings[rating]) return;
        seenRatings[rating] = true;
        histogram.push({
          rating: rating,
          count: parseInt(row.getAttribute('data-frequency') || '0', 10),
          pct: parseFloat(row.getAttribute('data-percentage') || '0')
        });
      });
      histogram.sort(function (a, b) { return b.rating - a.rating; });

      return { avg: avg, total: total, reviews: reviews, rawCount: reviewEls.length, histogram: histogram };
    }

    function makeCard(r) {
      const card = document.createElement('div');
      card.className = 'jm-reviews-card';

      if (r.photos && r.photos.length) {
        const imgWrap = document.createElement('div');
        imgWrap.className = 'jm-reviews-card__image';
        imgWrap.setAttribute('role', 'button');
        imgWrap.setAttribute('tabindex', '0');
        imgWrap.setAttribute('aria-label', 'View photo');
        const firstUrl = r.photos[0];
        let img;
        const vimeoId = jmVimeoId(firstUrl);
        const streamId = jmStreamId(firstUrl);
        const bunnyId = jmBunnyId(firstUrl);
        if (bunnyId) {
          img = document.createElement('img');
          img.src = jmBunnyThumbUrl(bunnyId);
          img.alt = '';
          img.loading = 'lazy';
          img.className = 'jm-reviews-card__video-thumb';
        } else if (vimeoId) {
          img = document.createElement('img');
          img.alt = '';
          img.loading = 'lazy';
          img.className = 'jm-reviews-card__video-thumb';
          img.style.objectFit = 'cover';
          img.style.width = '100%';
          img.style.height = '100%';
          (function (im, id) {
            // Vimeo oEmbed returns a NATIVE-aspect thumbnail (portrait for portrait
            // clips) like the Cloudflare ones, so object-fit:cover fills the card with
            // no letterboxing. vumbnail (forced 16:9) is only a last-resort fallback.
            fetch('https://vimeo.com/api/oembed.json?url=https://vimeo.com/' + id + '&width=640')
              .then(function (r) { return r.ok ? r.json() : null; })
              .then(function (d) { im.src = (d && d.thumbnail_url) ? d.thumbnail_url : ('https://vumbnail.com/' + id + '.jpg'); })
              .catch(function () { im.src = 'https://vumbnail.com/' + id + '.jpg'; });
          })(img, vimeoId);
        } else if (streamId) {
          img = document.createElement('img');
          img.src = 'https://videodelivery.net/' + streamId + '/thumbnails/thumbnail.jpg?time=' + (JM_THUMB_TIMES[streamId] || '2s') + '&width=540&height=676&fit=crop';
          img.alt = '';
          img.loading = 'lazy';
          img.className = 'jm-reviews-card__video-thumb';
        } else if (jmIsVideo(firstUrl)) {
          img = document.createElement('video');
          img.src = firstUrl;
          img.muted = true;
          img.loop = true;
          img.playsInline = true;
          img.setAttribute('muted', '');
          img.setAttribute('playsinline', '');
          img.preload = 'metadata';
          img.className = 'jm-reviews-card__video';
          const playP = img.play();
          if (playP && playP.catch) playP.catch(function () {});
        } else {
          img = document.createElement('img');
          img.src = firstUrl;
          img.alt = '';
          img.loading = 'lazy';
        }
        imgWrap.appendChild(img);
        // a media file that 404s would leave the browser's broken-image
        // glyph on a white 4:5 box; the words are the review, so the card
        // keeps them and drops the box (the masonry re-measures).
        if (img.tagName === 'IMG') {
          img.addEventListener('error', function () {
            if (!imgWrap.parentNode) return;
            imgWrap.remove();
            scheduleLayoutRefresh();
          }, { once: true });
        }

        // A video card looked identical to a photo card, so nothing told a
        // reader the tap would play anything. The badge is the affordance,
        // and it sits above the media rather than inside it so the muted
        // autoplaying preview cannot cover it.
        if (jmIsVideo(firstUrl)) {
          imgWrap.classList.add('jm-reviews-card__image--video');
          const play = document.createElement('span');
          play.className = 'jm-reviews-card__play';
          play.setAttribute('aria-hidden', 'true');
          play.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" focusable="false">'
            + '<path d="M9 7.5v9l7.5-4.5L9 7.5z" fill="currentColor"/>'
            + '</svg>';
          imgWrap.appendChild(play);
        }

        if (!jmIsVideo(firstUrl)) applyReviewImageRatio(r, imgWrap, img);

        if (r.photos.length > 1) {
          const badge = document.createElement('div');
          badge.className = 'jm-reviews-card__photo-count';
          badge.innerHTML = '<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true">'
            + '<rect x="0" y="0" width="5" height="5" rx="1" fill="currentColor"/>'
            + '<rect x="7" y="0" width="5" height="5" rx="1" fill="currentColor"/>'
            + '<rect x="0" y="7" width="5" height="5" rx="1" fill="currentColor"/>'
            + '<rect x="7" y="7" width="5" height="5" rx="1" fill="currentColor"/>'
            + '</svg>';
          const countSpan = document.createElement('span');
          countSpan.textContent = r.photos.length;
          badge.appendChild(countSpan);
          imgWrap.appendChild(badge);
        }

        imgWrap.addEventListener('click', function () { openLightbox(r.photos, 0, reviewMeta(r)); });
        imgWrap.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(r.photos, 0, reviewMeta(r)); }
        });
        card.appendChild(imgWrap);
      }

      const meta = document.createElement('div');
      meta.className = 'jm-reviews-card__meta';

      const avatar = document.createElement('span');
      avatar.className = 'jm-reviews-card__avatar';
      avatar.setAttribute('aria-hidden', 'true');
      avatar.textContent = (r.author || '?').trim().charAt(0).toUpperCase();
      avatar.style.background = avatarColor(r.author);

      const idWrap = document.createElement('div');
      idWrap.className = 'jm-reviews-card__id';

      const nameEl = document.createElement('span');
      nameEl.className = 'jm-reviews-card__name';
      nameEl.textContent = r.author;

      // All reviews are merchant-substantiated (customer studies and
      // interviews - Paul, Jun 12). Judge.me order-matching is unused on
      // this store, so r.verified stays false; the trust line reflects the
      // merchant attestation, stamped with the review's submission date.
      const badge = document.createElement('span');
      badge.className = 'jm-reviews-card__verified';
      let badgeHtml = '<svg class="jm-reviews-card__verified-seal" width="13" height="13" viewBox="0 0 24 24" aria-hidden="true">'
        + '<path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z" fill="#108a35"/>'
        + '<path d="m9 12 2 2 4-4" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        + '<span class="jm-reviews-card__verified-label">Verified</span>';
      const stamped = r.displayDate || formatDate(r.timestamp);
      if (stamped) {
        badgeHtml += '<span class="jm-reviews-card__verified-date">' + stamped + '</span>';
      }
      badge.innerHTML = badgeHtml;

      idWrap.appendChild(nameEl);
      idWrap.appendChild(badge);
      meta.appendChild(avatar);
      meta.appendChild(idWrap);

      const body = document.createElement('div');
      body.className = 'jm-reviews-card__body';
      body.innerHTML = starsHtml(r.rating, 16);

      const p = document.createElement('p');
      p.className = 'jm-reviews-card__text jm-reviews-card__text--collapsed';
      p.textContent = creatorQuoteFor(r.author) || r.body;
      body.appendChild(p);

      const readMoreBtn = document.createElement('button');
      readMoreBtn.className = 'jm-reviews-card__read-more';
      readMoreBtn.type = 'button';
      readMoreBtn.textContent = 'Read more';
      readMoreBtn.hidden = true;
      body.appendChild(readMoreBtn);
      setupReviewReadMore(r, p, readMoreBtn);

      card.appendChild(meta);
      card.appendChild(body);
      cardEls.push(card);
      return card;
    }

    function applyReviewImageRatio(review, imgWrap, img) {
      if (review.imageRatio) {
        imgWrap.style.setProperty('--jm-review-image-ratio', review.imageRatio);
        return;
      }

      function updateRatio() {
        if (!img.naturalWidth || !img.naturalHeight) return;
        review.imageRatio = img.naturalWidth + ' / ' + img.naturalHeight;
        imgWrap.style.setProperty('--jm-review-image-ratio', review.imageRatio);
        scheduleLayoutRefresh();
      }

      if (img.complete) updateRatio();
      else img.addEventListener('load', updateRatio, { once: true });
    }

    function scheduleLayoutRefresh() {
      clearTimeout(layoutRefreshTimer);
      layoutRefreshTimer = setTimeout(function () {
        if (!cardEls.length || !columns.length) return;
        // After Show More the grid is fully expanded; reshuffling it under the
        // reader (and re-creating every lazy <img>) is what flashed the page.
        if (userExpanded) { scheduleReadMoreRefresh(); return; }
        // Rebalance by MOVING the existing card nodes - never recreate them.
        // The old teardown (innerHTML = '' + re-running makeCard for every
        // review) re-made every lazy <img>/<video>, blanking the whole grid
        // white on each late image load (the Show More / swipe flicker).
        columns.forEach(function (col) { col.textContent = ''; });
        cardEls.forEach(function (card) {
          var shortestIdx = 0;
          var minH = columns[0].offsetHeight;
          for (var i = 1; i < columns.length; i++) {
            if (columns[i].offsetHeight < minH) { minH = columns[i].offsetHeight; shortestIdx = i; }
          }
          columns[shortestIdx].appendChild(card);
        });
        // reattaching can pause playing card videos in some engines - resume
        gridEl.querySelectorAll('video').forEach(function (v) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        });
        clipGridToGradient();
      }, 150);
    }

    function setupReviewReadMore(review, textEl, buttonEl) {
      function applyState() {
        const expanded = !!review.textExpanded;
        textEl.classList.toggle('jm-reviews-card__text--collapsed', !expanded);
        buttonEl.textContent = expanded ? 'Show less' : 'Read more';
        buttonEl.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }

      buttonEl.addEventListener('click', function () {
        review.textExpanded = !review.textExpanded;
        applyState();
        clipGridToGradient();
      });

      applyState();
      scheduleReadMoreRefresh();
    }

    function refreshReadMoreButtons() {
      gridEl.querySelectorAll('.jm-reviews-card__read-more').forEach(function (buttonEl) {
        const textEl = buttonEl.previousElementSibling;
        if (!textEl || !textEl.classList.contains('jm-reviews-card__text')) return;
        const wasExpanded = buttonEl.getAttribute('aria-expanded') === 'true';

        if (wasExpanded) {
          textEl.classList.add('jm-reviews-card__text--collapsed');
        }

        const overflows = textEl.scrollHeight > textEl.clientHeight + 1;
        buttonEl.hidden = !overflows && !wasExpanded;

        if (wasExpanded) {
          textEl.classList.remove('jm-reviews-card__text--collapsed');
        }
      });
    }

    function scheduleReadMoreRefresh() {
      clearTimeout(readMoreRefreshTimer);
      readMoreRefreshTimer = setTimeout(refreshReadMoreButtons, 0);
    }

    // figma's verified badge: blue scalloped seal with a knocked-out tick;
    // it sits between the average and count on mobile and before the
    // "verified reviews" total on the desktop scorecard
    const verifiedSvg = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">'
      + '<path fill="#0c79b0" fill-rule="evenodd" clip-rule="evenodd" d="M23 12l-2.44-2.79.34-3.69-3.61-.82L15.4 1.5 12 2.96 8.6 1.5 6.71 4.69 3.1 5.5l.34 3.7L1 12l2.44 2.79-.34 3.7 3.61.82L8.6 22.5l3.4-1.47 3.4 1.46 1.89-3.19 3.61-.82-.34-3.69L23 12zm-12.91 4.72l-3.8-3.81 1.48-1.48 2.32 2.33 5.85-5.87 1.48 1.48-7.33 7.35z"/>'
      + '</svg>';

    function mirrorToHeroRating(avg, total) {
      // The tripod PDP prints its hero rating as static liquid, so it cannot
      // know the live count. Overwrite it once judge.me answers; the markup in
      // the template stays as the no-JS / API-down fallback. A hero marked
      // data-static is deliberately pinned and keeps its own number.
      if (!(total > 0)) return;
      // Every server-rendered count below already prints this exact text in
      // the same markup, so write only when judge.me's answer actually differs:
      // an identical rewrite still swaps the nodes of the buy box's most-tapped
      // link, possibly under a finger.
      const countText = avg.toFixed(1) + ' (' + total.toLocaleString() + ' reviews)';
      function differs(el, text) {
        return el.textContent.replace(/\s+/g, ' ').trim() !== text;
      }
      const heroCount = document.querySelector('.tpd-rating__count:not([data-static])');
      if (heroCount && differs(heroCount, countText)) {
        heroCount.innerHTML = avg.toFixed(1) + ' (' + total.toLocaleString()
          + '<span class="tpd-swap--desktop"> reviews</span>)';
      }
      // The pad PDP does the same thing with its own markup: the liquid ships a
      // static rating so the buy box is never blank, and judge.me replaces it.
      // Same opt-out as the tripod hero: a count marked data-static is pinned on
      // purpose. The pad quotes its own 345 while this section is pointed at the
      // simulator's reviews, so judge.me must not overwrite it with 22,964.
      const padCount = document.querySelector('.bb-reviews-link:not([data-static])');
      if (padCount && differs(padCount, countText)) {
        padCount.innerHTML = avg.toFixed(1) + ' (' + total.toLocaleString()
          + '<span class="rv-word"> reviews</span>)';
      }
      const stickyCount = document.querySelector('.sb-reviews-count:not([data-static])');
      const stickyText = total.toLocaleString() + ' Reviews';
      if (stickyCount && differs(stickyCount, stickyText)) stickyCount.textContent = stickyText;
    }

    function renderSummary(avg, total, hist) {
      mirrorToHeroRating(avg, total);
      const starsMarkup = [1, 2, 3, 4, 5].map(function (i) { return starSvg(i <= Math.round(avg), 40); }).join('');
      summaryEl.innerHTML = '<div class="jm-reviews-summary__stars" role="img" aria-label="Rating: ' + avg.toFixed(1) + ' out of 5">' + starsMarkup + '</div>'
        + '<span class="jm-reviews-summary__avg">' + avg.toFixed(1) + '</span>'
        + '<span class="jm-reviews-summary__verified" title="Verified reviews">' + verifiedSvg + '</span>'
        + '<span class="jm-reviews-summary__count">(' + total.toLocaleString() + ' reviews)</span>';

      // Desktop scorecard: big average + stars + verified total. Paul (Jun 12):
      // focus on total reviews and overall rating only - no per-star breakdown.
      if (!(total > 0)) return;
      summaryEl.classList.add('jm-reviews-summary--scorecard');
      const starsSmall = [1, 2, 3, 4, 5].map(function (i) { return starSvg(i <= Math.round(avg), 24); }).join('');
      summaryEl.insertAdjacentHTML('beforeend',
        '<div class="jm-reviews-scorecard">'
        + '<div class="jm-reviews-scorecard__num">' + avg.toFixed(1) + '</div>'
        + '<div class="jm-reviews-scorecard__right">'
        + '<div class="jm-reviews-scorecard__stars" role="img" aria-label="Rating: ' + avg.toFixed(1) + ' out of 5">' + starsSmall + '</div>'
        + '<div class="jm-reviews-scorecard__sub"><span class="jm-reviews-scorecard__verified" title="Verified reviews">' + verifiedSvg + '</span>' + total.toLocaleString() + ' verified reviews</div>'
        + '</div>'
        + '</div>');
    }

    // Video reviews lead. They are the most persuasive thing in the set and
    // the only ones that need a tap to pay off, so they should not be buried
    // behind the text-only ones. Stable: within each group the original
    // order (which is Judge.me's own) is untouched.
    function videoFirst(reviews) {
      const vids = [];
      const rest = [];
      reviews.forEach(function (r) {
        const first = (r.photos && r.photos[0]) || '';
        (jmIsVideo(first) ? vids : rest).push(r);
      });
      return vids.concat(rest);
    }

    // ---------- Featured Reviews ----------
    // The newest video reviews, in the order Judge.me returns them (page 1
    // is newest first), so "most recent" needs no synthetic date. The
    // displayDate on a card is staggered for the bulk-imported seed set and
    // would be the wrong thing to sort on.
    function fmtDuration(seconds) {
      const total = Math.round(seconds);
      if (!(total > 0)) return '';
      return Math.floor(total / 60) + ':' + String(total % 60).padStart(2, '0');
    }

    // onDuration fires only when a real length is known: Vimeo ships it in
    // the same oEmbed response the poster already needs, a plain file
    // reports it on loadedmetadata, and Cloudflare Stream offers neither
    // without an API key, so a Stream card simply shows no chip.
    function buildFeaturedThumb(url, onDuration) {
      const vimeoId = jmVimeoId(url);
      const streamId = jmStreamId(url);
      const bunnyId = jmBunnyId(url);

      if (bunnyId) {
        const im = document.createElement('img');
        im.src = jmBunnyThumbUrl(bunnyId);
        im.alt = '';
        im.loading = 'lazy';
        im.className = 'jm-featured__poster';
        return im;
      }

      if (vimeoId) {
        const im = document.createElement('img');
        im.alt = '';
        im.loading = 'lazy';
        im.className = 'jm-featured__poster';
        fetch('https://vimeo.com/api/oembed.json?url=https://vimeo.com/' + vimeoId + '&width=640')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) {
            im.src = (d && d.thumbnail_url) ? d.thumbnail_url : ('https://vumbnail.com/' + vimeoId + '.jpg');
            if (d && d.duration && onDuration) onDuration(d.duration);
          })
          .catch(function () { im.src = 'https://vumbnail.com/' + vimeoId + '.jpg'; });
        return im;
      }

      if (streamId) {
        const im = document.createElement('img');
        im.src = 'https://videodelivery.net/' + streamId + '/thumbnails/thumbnail.jpg?time='
          + (JM_THUMB_TIMES[streamId] || '2s') + '&width=540&height=960&fit=crop';
        im.alt = '';
        im.loading = 'lazy';
        im.className = 'jm-featured__poster';
        return im;
      }

      // a plain file: the muted looping frame is its own poster
      const v = document.createElement('video');
      v.src = url;
      v.muted = true;
      v.loop = true;
      v.playsInline = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.preload = 'metadata';
      v.className = 'jm-featured__poster';
      if (onDuration) {
        v.addEventListener('loadedmetadata', function () { onDuration(v.duration); }, { once: true });
      }
      const p = v.play();
      if (p && p.catch) p.catch(function () {});
      return v;
    }

    function makeFeaturedCard(r) {
      const url = r.photos[0];

      // The card itself is the control. One handler on the wrapper beats a
      // button on just the thumbnail: on a phone people tap the name.
      const card = document.createElement('article');
      card.className = 'jm-featured__card';
      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', '0');
      card.setAttribute('aria-label', 'Play the video review from ' + r.author);
      card.addEventListener('click', function () { openLightbox(r.photos, 0, reviewMeta(r)); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(r.photos, 0, reviewMeta(r)); }
      });

      const media = document.createElement('div');
      media.className = 'jm-featured__media';

      const dur = document.createElement('span');
      dur.className = 'jm-featured__dur';
      dur.hidden = true;

      const thumb = buildFeaturedThumb(url, function (seconds) {
        const label = fmtDuration(seconds);
        if (!label) return;
        dur.textContent = label;
        dur.hidden = false;
      });
      // A poster that 404s paints a black 3:4 box with the browser's
      // broken-image glyph, and in GAH-REVIEWS-01 arm B this rail is the
      // first new screen under the buy box. A card with no footage is not
      // a video review: drop it and re-count the dots.
      if (thumb.tagName === 'IMG') {
        thumb.addEventListener('error', function () { dropFeaturedCard(card); }, { once: true });
      }
      media.appendChild(thumb);
      media.appendChild(dur);

      const play = document.createElement('span');
      play.className = 'jm-reviews-card__play';
      play.setAttribute('aria-hidden', 'true');
      play.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" focusable="false"><path d="M9 7.5v9l7.5-4.5L9 7.5z" fill="currentColor"/></svg>';
      media.appendChild(play);
      card.appendChild(media);

      const meta = document.createElement('div');
      meta.className = 'jm-featured__meta';
      const name = document.createElement('p');
      name.className = 'jm-featured__name';
      const handle = creatorHandleFor(r.author);
      name.textContent = handle || r.author;
      if (handle) name.classList.add('jm-featured__name--handle');
      meta.appendChild(name);
      meta.insertAdjacentHTML('beforeend', starsHtml(r.rating, 13));
      card.appendChild(meta);

      const quoteSource = creatorQuoteFor(r.author) || r.body;
      if (quoteSource) {
        const quote = document.createElement('p');
        quote.className = 'jm-featured__quote';
        // trimmed on the last whole word: a mid-word cut reads as a bug
        let text = quoteSource;
        if (text.length > 85) {
          const cut = text.slice(0, 85);
          const space = cut.lastIndexOf(' ');
          text = (space > 40 ? cut.slice(0, space) : cut).trim() + '...';
        }
        quote.textContent = text;
        card.appendChild(quote);
      }

      return card;
    }

    function dropFeaturedCard(card) {
      if (!card.parentNode) return;
      card.remove();
      const left = featuredRailEl.querySelectorAll('.jm-featured__card').length;
      if (!left) { featuredEl.hidden = true; return; }
      const dots = featuredEl.querySelector('.jm-featured__dots');
      if (dots) dots.remove();
      wireFeaturedDots(left);
      // the arrows listen on scroll; one synthetic scroll re-reads the edges
      featuredRailEl.dispatchEvent(new Event('scroll'));
    }

    function renderFeatured(reviews) {
      if (!featuredEl || !featuredRailEl) return [];

      // partnership creator cards rendered by Liquid lead the rail; the
      // newest customer video reviews follow them
      const staticCards = featuredRailEl.querySelectorAll('[data-jm-static-video]');
      staticCards.forEach(function (btn) {
        if (btn.dataset.jmWired) return;
        btn.dataset.jmWired = '1';
        btn.addEventListener('click', function () { openLightbox([btn.dataset.jmStaticVideo], 0); });
      });

      const picks = reviews.filter(function (r) {
        return r.photos && r.photos.length && jmIsVideo(r.photos[0]);
      }).slice(0, featuredCount);

      if (!picks.length && !staticCards.length) return [];

      picks.forEach(function (r) { featuredRailEl.appendChild(makeFeaturedCard(r)); });
      featuredEl.hidden = false;
      wireFeaturedDots(picks.length + staticCards.length);
      wireFeaturedArrows();
      return picks;
    }

    // The peek alone does not say the row continues - the Play at Home
    // rail died of exactly that ("with no dots", Aug 23 sweep). Progress
    // fraction, not stride counting: the last card can never scroll a
    // full stride past the edge, so counting strides would leave the
    // final dot unreachable.
    function wireFeaturedDots(count) {
      if (count < 2) return;
      const dots = document.createElement('div');
      dots.className = 'jm-featured__dots';
      dots.setAttribute('aria-hidden', 'true');
      for (let i = 0; i < count; i++) {
        const d = document.createElement('i');
        if (i === 0) d.className = 'on';
        dots.appendChild(d);
      }
      featuredEl.appendChild(dots);

      function sync() {
        const max = featuredRailEl.scrollWidth - featuredRailEl.clientWidth;
        if (max <= 0) { dots.hidden = true; return; }
        dots.hidden = false;
        const i = Math.round((featuredRailEl.scrollLeft / max) * (count - 1));
        [...dots.children].forEach(function (d, k) { d.classList.toggle('on', k === i); });
      }

      featuredRailEl.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }

    function wireFeaturedArrows() {
      const prev = featuredEl.querySelector('[data-jm-featured-prev]');
      const next = featuredEl.querySelector('[data-jm-featured-next]');
      if (!prev || !next) return;

      function step() {
        const card = featuredRailEl.querySelector('.jm-featured__card');
        if (!card) return featuredRailEl.clientWidth;
        // one card plus the gap, so an arrow lands on the next card's edge
        const gap = parseFloat(getComputedStyle(featuredRailEl).columnGap || '12') || 12;
        return card.getBoundingClientRect().width + gap;
      }

      const nav = featuredEl.querySelector('.jm-featured__nav');

      function sync() {
        const max = featuredRailEl.scrollWidth - featuredRailEl.clientWidth - 2;
        // five cards can fit the desktop rail exactly, and a pair of
        // permanently greyed arrows reads as a broken control
        if (nav) nav.hidden = max <= 2;
        prev.disabled = featuredRailEl.scrollLeft <= 2;
        next.disabled = featuredRailEl.scrollLeft >= max;
      }

      prev.addEventListener('click', function () {
        featuredRailEl.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        featuredRailEl.scrollBy({ left: step(), behavior: 'smooth' });
      });
      featuredRailEl.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }

    function appendCards(reviews) {
      reviews.forEach(function (r) {
        let shortestIdx = 0;
        let minH = columns[0].offsetHeight;
        for (let i = 1; i < columns.length; i++) {
          if (columns[i].offsetHeight < minH) {
            minH = columns[i].offsetHeight;
            shortestIdx = i;
          }
        }
        columns[shortestIdx].appendChild(makeCard(r));
      });
    }

    function fillShortColumns(reviews) {
      const gradientLine = moreEl.getBoundingClientRect().top - 220;
      const shortCols = columns.filter(function (col) {
        return col.getBoundingClientRect().bottom < gradientLine;
      });
      let idx = 0;
      while (idx < reviews.length && shortCols.length > 0) {
        const col = shortCols.shift();
        col.appendChild(makeCard(reviews[idx++]));
        if (col.getBoundingClientRect().bottom < gradientLine) {
          shortCols.push(col);
        }
      }
      return reviews.slice(idx);
    }

    // figma cuts the masonry at a fixed line and lays the fade over the cut, so
    // cards are bisected on purpose. Desktop 34980:143767 puts the Show More
    // button at 934 under a grid that opens at 294; mobile 34980:143350 puts it
    // at 1009 under a grid that opens at 222. Both leave a 32/24px step between
    // the clip and the button, which is what these two heights subtract.
    // desktop: figma's grid frame is 294 -> 990 (696 tall) and the Show More
    // button is laid over its last 56px, so cards stay visible behind the fade
    // instead of stopping above a clean white gap. The CSS pulls the button
    // back up over the clip, so the section still closes where figma does.
    const CLIP_DESKTOP = 696;
    const CLIP_MOBILE = 763;

    function figmaClipHeight() {
      return window.innerWidth >= 992 ? CLIP_DESKTOP : CLIP_MOBILE;
    }

    function clipGridToGradient() {
      // the fade lives on the grid itself (see .jm-reviews-grid.is-clipped),
      // so it tracks the clip edge at every viewport width instead of being
      // painted at a fixed offset from the Show More row
      if (userExpanded) {
        gridEl.style.maxHeight = '';
        gridEl.classList.remove('is-clipped');
        return;
      }
      if (!initialClipDone) {
        initialClipDone = true;
        gridEl.style.maxHeight = figmaClipHeight() + 'px';
        gridEl.classList.add('is-clipped');
        return;
      }
      if (moreEl.hidden) {
        gridEl.style.maxHeight = '';
        gridEl.classList.remove('is-clipped');
        return;
      }
      gridEl.style.maxHeight = figmaClipHeight() + 'px';
      gridEl.classList.add('is-clipped');
    }

    function isGridFilled() {
      if (moreEl.hidden || !columns.length) return true;
      const gradientLine = moreEl.getBoundingClientRect().top - 220;
      return columns.every(function (col) {
        return col.getBoundingClientRect().bottom >= gradientLine;
      });
    }

    async function fetchWidget(page) {
      const res = await fetch(widgetUrl(page));
      if (!res.ok) throw new Error('fetch failed: ' + res.status);
      const data = await res.json();
      return data.widget || '';
    }

    async function fetchNextDisplayableReviews() {
      let scannedPages = 0;

      while (scannedPages < maxEmptyScanPages) {
        const html = await fetchWidget(currentPage);
        const parsed = parseWidget(html);
        currentPage++;
        scannedPages++;

        if (parsed.reviews.length > 0 || parsed.rawCount < perPage) {
          return parsed;
        }
      }

      return { reviews: [], rawCount: 0, reachedDisplayLimit: true };
    }

    function hideMoreButton() {
      moreEl.hidden = true;
      moreBtnEl.disabled = false;
      moreBtnEl.textContent = showMoreLabel;
    }

    async function ensureMoreButtonHasReviews() {
      if (moreEl.hidden || pendingReviews.length > 0) return true;

      if (pendingIsLast) {
        hideMoreButton();
        return false;
      }

      const parsed = await fetchNextDisplayableReviews();
      pendingReviews = markFresh(parsed.reviews);
      pendingIsLast = parsed.rawCount < perPage || parsed.reachedDisplayLimit;

      if (pendingReviews.length === 0) {
        hideMoreButton();
        return false;
      }

      return true;
    }

    async function init() {
      try {
        const html = await fetchWidget(1);
        const parsed = parseWidget(html);

        // Optional display overrides (e.g. a new product borrowing another
        // product's review cards but stating its own modest rating/count).
        const ovAvg = parseFloat(root.dataset.overrideRating || '') || 0;
        const ovTotal = parseInt(root.dataset.overrideCount || '', 10) || 0;
        renderSummary(ovAvg || parsed.avg, ovTotal || parsed.total, parsed.histogram);
        const fetched = videoFirst(markFresh(parsed.reviews));
        const featuredPicks = renderFeatured(fetched);
        // a review appears once: whatever the rail took is not repeated
        // immediately underneath it in the grid
        allReviews = fetched.filter(function (r) { return featuredPicks.indexOf(r) === -1; });
        setupColumns();
        skeletonEl.hidden = true;
        gridEl.hidden = false;
        // the heading only earns its place once there are cards under it
        var gridHead = document.getElementById(sid + '-grid-head');
        if (gridHead) gridHead.hidden = false;
        appendCards(allReviews);

        if (parsed.rawCount >= perPage) {
          currentPage = 2;
          moreEl.hidden = false;

          // Button stays ENABLED during the background prefetch — a click
          // during this window queues behind initPrefetch instead of being
          // swallowed (the old disabled state ate the first tap).
          initPrefetch = (async function () {
            try {
              const extraHtml = await fetchWidget(currentPage);
              const extraParsed = parseWidget(extraHtml);
              const numCols = columns.length;
              const freshExtra = markFresh(extraParsed.reviews);
              const extraToShow = freshExtra.slice(0, numCols);

              if (extraToShow.length > 0) {
                allReviews = allReviews.concat(extraToShow);
                appendCards(extraToShow);
              }

              pendingReviews = freshExtra.slice(numCols);
              pendingIsLast = extraParsed.rawCount < perPage;
              currentPage = 3;

              if (pendingIsLast && pendingReviews.length === 0) {
                moreEl.hidden = true;
              }
            } catch (_) {}

            if (!moreEl.hidden) {
              await ensureMoreButtonHasReviews();
            }
            initPrefetch = null;
          })();
        }

        clipGridToGradient();
      } catch (_) {
        skeletonEl.hidden = true;
        errorEl.hidden = false;
      }
    }

    async function loadMore() {
      const MAX_FILL = 3;
      let fillCount = 0;
      userExpanded = true;
      gridEl.style.maxHeight = '';

      moreBtnEl.disabled = true;
      moreBtnEl.textContent = 'Loading...';
      if (initPrefetch) { try { await initPrefetch; } catch (_) {} }

      try {
        let reviewsToAdd;
        let isLastPage;

        if (pendingReviews.length > 0) {
          reviewsToAdd = pendingReviews;
          isLastPage = pendingIsLast;
          pendingReviews = [];
        } else {
          const parsed = await fetchNextDisplayableReviews();
          reviewsToAdd = markFresh(parsed.reviews);
          isLastPage = parsed.rawCount < perPage || parsed.reachedDisplayLimit;
        }

        if (reviewsToAdd.length > 0) {
          allReviews = allReviews.concat(reviewsToAdd);
          appendCards(reviewsToAdd);
        }

        if (isLastPage) {
          hideMoreButton();
          clipGridToGradient();
          return;
        }

        if (reviewsToAdd.length === 0) {
          hideMoreButton();
          clipGridToGradient();
          return;
        }

        while (!isGridFilled() && fillCount < MAX_FILL) {
          const fillParsed = await fetchNextDisplayableReviews();

          const freshFill = markFresh(fillParsed.reviews);
          if (freshFill.length > 0) {
            allReviews = allReviews.concat(freshFill);
            const leftover = fillShortColumns(freshFill);
            appendCards(leftover);
          }

          if (fillParsed.rawCount < perPage || fillParsed.reachedDisplayLimit) {
            hideMoreButton();
            clipGridToGradient();
            return;
          }

          fillCount++;
        }

        await ensureMoreButtonHasReviews();
        if (!moreEl.hidden) {
          moreBtnEl.disabled = false;
          moreBtnEl.textContent = showMoreLabel;
        }
        clipGridToGradient();
      } catch (_) {
        moreBtnEl.disabled = false;
        moreBtnEl.textContent = showMoreLabel;
        clipGridToGradient();
      }
    }

    if (writeBtnEl) {
      writeBtnEl.addEventListener('click', function () {
        const jdgmBtn = document.querySelector('.jdgm-write-rev-link');
        if (jdgmBtn) jdgmBtn.click();
      });
    }

    let resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        const n = getNumCols();
        if (n === lastNumCols) return;
        initialClipDone = false;
        // the column COUNT changed (orientation flip): this path legitimately
        // recreates every card, so reset the moved-node registry first or the
        // rebalancer would append stale duplicates. textExpanded/imageRatio
        // live on the review objects, so recreated cards keep their state.
        cardEls = [];
        setupColumns();
        appendCards(allReviews);
        clipGridToGradient();
      }, 150);
    });

    moreBtnEl.addEventListener('click', loadMore);

    // Lazy boot. The wall sits about halfway down a long PDP and roughly 13%
    // of mobile sessions ever reach it, yet it fetched two Judge.me pages and
    // built its cards on every load. Start it when it comes within 1500px of
    // the viewport, when the page opens on #reviews, or at idle after window
    // load - whichever comes first - so a rating tap after load still lands on
    // a finished wall. Only the start moves; init() itself is unchanged.
    // NOT on the Golf At Home PDP (suffix divot_daddy_pro_splittest, which the
    // CA twin shares) while GAH-PEEK-01 runs: its control arm IS the rating
    // tap's jump to this wall, and gating it would change that arm alone. Drop
    // this exclusion once PEEK-01 has been read out.
    const tpl = window._template;
    const lazyBoot = !!(tpl && tpl.suffix !== 'divot_daddy_pro_splittest');
    if (!lazyBoot) {
      init();
    } else {
      let started = false;
      let io = null;
      const start = function () {
        if (started) return;
        started = true;
        if (io) io.disconnect();
        init();
      };
      // Safari and every iOS webview have no requestIdleCallback: keep the
      // fallback short, a longer one only widens the skeleton window
      const idleStart = function () {
        if ('requestIdleCallback' in window) window.requestIdleCallback(start, { timeout: 2000 });
        else setTimeout(start, 1);
      };
      if (!('IntersectionObserver' in window) || window.location.hash === '#reviews') {
        start();
      } else {
        io = new IntersectionObserver(function (entries) {
          if (entries.some(function (entry) { return entry.isIntersecting; })) start();
        }, { rootMargin: '1500px 0px' });
        io.observe(root);
        if (document.readyState === 'complete') idleStart();
        else window.addEventListener('load', idleStart, { once: true });
      }
    }
  });
})();
